import * as React from 'react';
import styled from 'styled-components';
import { useDataGridContext } from '../context';
import { strIsNullOrEmpty } from '@fox/atoms/utils/string';
import { Spin } from '@fox/atoms/src/spin/index';
import { RowPlaceholder } from './index';

const SpinWrapper = styled.div`
	display: grid;
	width: 100%;
	place-items: center;
	._loading_overlay_wrapper {
		width: 100%;
		border-radius: 0;
	}
	._loading_overlay_overlay {
		border-radius: 0;
		background-color: transparent;
	}
	._loading_overlay_content {
		color: ${props => props.theme.colors.font} !important;
		svg circle {
			stroke: ${props => props.theme.colors.font} !important;
		}
	}
`;

export const LoadingDataGridDataPlaceholder = () => {
	const { loadingDataMessage } = useDataGridContext();
	return (
		<RowPlaceholder style={{ padding: 0 }}>
			<SpinWrapper>
				<Spin
					size="small"
					tip={!strIsNullOrEmpty(loadingDataMessage) ? loadingDataMessage : `Loading Data`}
					spinning
					minHeight={75}
				/>
			</SpinWrapper>
		</RowPlaceholder>
	);
};
